<template>
  <div class="input input-icon-search w-100">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      :value="textSearch"
      @blur="handleBlur($event)"
      @keydown="handleKeyDownInner"
      @keyup="handleKeyup"
      @focus="setVKB(false)"
      class="w-100"
      :class="{ 'has-switch-btns': $slots.default }"
      v-focus="{ nofocus: this.nofocus != undefined ? nofocus : false }"
      @dblclick.stop
      v-select.focus="{ nofocus: this.nofocus != undefined ? nofocus : false }"
    />
    <slot></slot>
    <BaseIcon
      v-if="showVirtualKeyBoard"
      class="keyboard-icon"
      :style="{ left: '34px' }"
      nameIcon="keyboard"
      pathIcon="k"
      :height="20"
      :width="20"
      v-tooltip="{
        content: $t('mainTools.keyboardOnScreen'),
        placement: 'right',
      }"
      @click="setVKB"
      ref="kb"
    />
    <div
      v-if="fill"
      class="icon-cancel otz-icon no-bg clear-input"
      :style="{
        left: showVirtualKeyBoard ? '50px' : '29px',
      }"
      @click="clear"
    >
      F
    </div>
    <Icons
      class="icon-general icon-search"
      icon="magnifier"
      height="12px"
      width="12px"
      @click="search"
    />
    <!--  <div class="icon-general icon-search" @click="search">d</div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Icons from "@/components/Icons/Icons.vue";
import mixInputCharsTranslate from "@/mixing/mixInputCharsTranslate";
export default {
  mixins: [mixInputCharsTranslate],
  props: ["placeholder", "text", "nofocus", "showPageIcon"],
  data() {
    return {
      textSearch: "",
      searchCurrentPage: false,
      // textValue: ""
    };
  },
  components: { Icons },
  computed: {
    ...mapState("vKeyBoard", ["vKeyBoardInput", "vKeyBoardInputName"]),
    showVirtualKeyBoard() {
      const react = this.$store.state.inputKeyboardChange;
      return localStorage.getItem("virtualKeyBoard") == "1";
    },
    fill() {
      //
      if (this.textSearch != "") return true;
      return false;
    },
  },
  methods: {
    ...mapActions("vKeyBoard", [
      "setKeyBoardDisplay",
      "setKeyBoardInputName",
      "setKeyBoardInput",
    ]),
    handleKeyDownInner(event) {
      if (event.code == "Enter") {
        this.search();
        return;
      }
      if (!this.isSpecialKeys(event))
        this.handleKeydown(event, this.$refs.input);
    },
    handleKeyup(event) {
      this.keyupInput(event);
    },
    setVKB(showKB = true) {
      this.setKeyBoardInputName(this.$refs.input.id);
      if (showKB) this.setKeyBoardDisplay(true);
    },
    keyupInput(e, str) {
      let txt;
      if (e) {
        txt = e.target.value.replace(/\s\s$/g, "-");
        this.textSearch = txt;
        this.setKeyBoardInput(this.textSearch);
        this.$emit("input", e);
      } else {
        str = str.replace(/\s\s/g, "-");

        this.textSearch = str;
        this.setKeyBoardInput(str);
        this.$emit("input", str);
      }
    },
    handleBlur(e) {
      this.$emit("blur", e);
    },
    clear() {
      this.textSearch = "";
      this.$refs.input.focus();
      this.setKeyBoardInput("");
      this.$emit("clear");
    },
    setFocus() {
      this.$refs.input.focus();
    },
    search() {
      this.$emit("search");
    },
  },
  mounted() {
    if (this.$refs.kb) this.$refs.kb.$el.style.left = "34px";

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.textSearch = this.text || "";
      // this.$refs.input.focus();
      // this.$refs.input.select();

      this.$refs.input.id = `base_input_${Math.random(1 % 10000000)}`;
    });
  },
  watch: {
    text: function (v, ov) {
      this.textSearch = v;
    },
    vKeyBoardInput: function (val) {
      if (this.$refs.input.id == this.vKeyBoardInputName) {
        this.keyupInput(null, val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-color1: #fff;
.icon-cancel {
  cursor: pointer;
  width: 20px;
  border-radius: 50%;
  height: 20px;
  text-align: center;
  transition: 0.3s;
  font-size: 8px;
  position: absolute;
  top: 2.5px;
  left: 50px;
  &:hover {
    background-color: #00000014;
  }
}
.input-icon-search.input {
  margin: 0;
  position: relative;
  .icon-general {
    position: absolute;
    height: 25px;
    line-height: 25px;
    top: 0;

    &.icon-search {
      // fill: var(--custom-color1) !important;
      stroke: var(--custom-color1) !important;
      left: 13px;
      color: var(--custom-color1);
      transition: 0.3s;
      border-radius: 50%;
      width: 14px;
      left: 11px;
      margin-left: 5px;
      cursor: pointer;
      /*  &:hover {
        background-color: #d1d1d1;
      }
      &.active {
        background-color: #a7a7a7;
      } */
    }
  }

  input {
    display: block;
    // padding: 0 15px 0 40px; VERY DANGER CHANGE
    border: 1px solid var(--custom-color1);
    background-color: $bg-color1;
    height: 25px;
    font-size: 13px;
    font-weight: bold;
    color: #000;
    line-height: 25px;
    transition: 0.3s;
    margin: 0;
    &:focus {
      border-color: var(--custom-color1);
    }
    &::placeholder {
      font-size: 13px !important;
      font-weight: 300 !important;
      color: var(--text-color2) !important;
    }
  }
}
.has-switch-btns {
  padding-right: 51px !important;
  border-radius: 13px 3px 3px 13px !important;
  border: 1px solid #dedede !important;
  background: #f7f7f7 !important;
}
.keyboard-icon {
  position: absolute;
  left: 33px;
  top: 3px;
  cursor: pointer;
}
</style>
